import { ProductDumpApiContext } from 'components/common-form/contexts/ProductDumpContext';
import { useUserNotification } from 'hooks/useUserNotification';
import { useCallback, useContext, useState } from 'react';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { downloadZip } from 'utils/documents/downloadDocument';

export interface DownloadProductDumpMarketDataApi {
  downloadProductDumpMarketData(pricingId: string): Observable<Blob>;
}

export const useProductDumpMarketData = (
  errorMessage = 'An error occurred while downloading market data. Please contact the support team if it persists.',
) => {
  const userNotification = useUserNotification();
  const productDumpApi = useContext(ProductDumpApiContext)!;
  const [isProductDumpMarketDataDownloading, setIsProductDumpMarketDataDownloading] = useState(false);

  const downloadProductDumpMarketData = useCallback(
    (pricingId: string) => {
      setIsProductDumpMarketDataDownloading(true);
      const dump$: Observable<Blob> = productDumpApi.downloadProductDumpMarketData(pricingId).pipe(
        finalize(() => {
          setIsProductDumpMarketDataDownloading(false);
        }),
      );
      dump$.subscribe({
        next(blob: Blob) {
          downloadZip(blob, `${pricingId}_productDump_MarketData.txt`);
        },
        error() {
          userNotification.error({ title: { id: 'toast.export' }, content: [errorMessage] });
        },
      });
    },
    [productDumpApi, userNotification, errorMessage],
  );

  return {
    isProductDumpMarketDataDownloading,
    downloadProductDumpMarketData,
  };
};
